import React, { useState, useEffect, useRef } from 'react'
import Toolbar from './components/Toolbar'
import TimeNavigation from './components/TimeNavigation'
import WebGLCanvas from './components/WebGLCanvas'

const App: React.FC = () => {
  const [verticalViewingAngle, setVerticalViewingAngle] = useState(10)
  const [currentTime, setCurrentTime] = useState(new Date())
  const appRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      e.preventDefault()

      // Determine zoom direction: negative deltaY = zoom in, positive = zoom out
      const zoomFactor = e.deltaY > 0 ? 1.1 : 0.9

      setVerticalViewingAngle((prevAngle) => {
        const newAngle = prevAngle * zoomFactor
        // Clamp between 0.1 and 90 degrees
        return Math.max(0.1, Math.min(90, newAngle))
      })
    }

    const appElement = appRef.current
    if (appElement) {
      appElement.addEventListener('wheel', handleWheel, { passive: false })
    }

    return () => {
      if (appElement) {
        appElement.removeEventListener('wheel', handleWheel)
      }
    }
  }, [])

  return (
    <div ref={appRef} className="w-full h-full flex flex-col">
      <Toolbar />
      <WebGLCanvas
        verticalViewingAngle={verticalViewingAngle}
        currentTime={currentTime}
      />
      <TimeNavigation
        verticalViewingAngle={verticalViewingAngle}
        setVerticalViewingAngle={setVerticalViewingAngle}
        currentTime={currentTime}
        setCurrentTime={setCurrentTime}
      />
    </div>
  )
}

export default App
